/* eslint-disable no-console */

import { register } from 'register-service-worker'
import {store_setStateValue, store_var} from "./store";
import { gv_env } from './scripts/S_GlobalVar';

if(!gv_env.localhost_b){
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready () {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )

        },
        registered () {
            console.log('Service worker has been registered.')
        },
        cached () {
            console.log('Content has been cached for offline use.')
            store_setStateValue(store_var.system_serviceWorkerCacheLoader_b, false)
        },
        updatefound () {
            console.log('New content is downloading.')
            store_setStateValue(store_var.system_serviceWorkerCacheLoader_b, true)
        },
        updated () {
            console.log('New content is available; please refresh.')

            // route_refreshPage()
            store_setStateValue(store_var.system_serviceWorkerCacheLoader_b, false)
        },
        offline () {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error (error) {
            console.error('Error during service worker registration:', error)
        }
    })
}